import type { CurrencyCode } from 'app/api/services/site-configs/types';

// ---

export type PledgeStakeSingleDAO = {
  stakeId: number;
  createdAt: string;
  matchStartDate: string;
  matchName: string;
  stakeName: string;
  betName: string;
  sum: number;
  currency: CurrencyCode;
  price: number;
  isFreeBet: boolean;
  maxWinning: number;
};

export type PledgeStakeChainDAO = {
  stakeId: number;
  chainMatches: string[];
  sum: number;
  currency: CurrencyCode;
  maxWinning: number;
};

export type PledgeStakeDAO = PledgeStakeSingleDAO | PledgeStakeChainDAO;

export type PledgeStakesDAO = {
  singleStakes: PledgeStakeSingleDAO[];
  chainStakes: PledgeStakeChainDAO[];
};

export function isChainPledgeStake(
  pledgeStake: PledgeStakeDAO,
): pledgeStake is PledgeStakeChainDAO {
  return 'chainMatches' in pledgeStake;
}
